import { Link } from '@/global/components/Link'
import Grid from '@/global/components/ui/Grid'
import { FormField } from 'global/components/Form'
import { SelectColaboradores } from './SelectColaboradores'
import { SelectFunction } from './SelectFuncoes'

export function FormAvaliacao() {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeResponsavel"
                    label="Nome completo"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeFantasia"
                    label="Nome da empresa"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="emailResponsavel"
                    label="Email para login"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="telefone"
                    label="Telefone para contato (com DDD)"
                    options={{
                        phone: true,
                        phoneRegionCode: 'BR',
                    }}
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField name="senha" label="Senha" hiddenPassword required />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme sua senha"
                    hiddenPassword
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectFunction required />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectColaboradores required />
            </Grid>

            <Grid item xs={12}>
                <span className="text-xs text-secondary">
                    Ao iniciar o teste grátis, você está concordando com os{' '}
                    <Link
                        href="https://sistemapontoagil.com.br/termos"
                        rel="external"
                    >
                        Termos de Uso
                    </Link>{' '}
                    e{' '}
                    <Link
                        href="https://sistemapontoagil.com.br/politicas"
                        rel="external"
                    >
                        Política de Privacidade
                    </Link>
                    .
                </span>
            </Grid>
        </Grid>
    )
}
